import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "app/components/Input";
import Button from "app/components/Button";
import EmailIcon from "app/components/Icons/EmailIcon";
import { useNavigate } from "react-router-dom";
import { selectIsGoogleLogin, selectSignupForm } from "../../redux/selector";
import { validateSignupForm } from "../../helpers";
import { actions } from "../../redux/slice";
import GoogleButton from "./GoogleButton";

type Props = {
  isEmail: boolean;
  setIsEmail: (val: boolean) => void;
  searchParams: string;
};

export default function SignupForm({
  isEmail,
  setIsEmail,
  searchParams,
}: Props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const form = useSelector(selectSignupForm);
  const isGoogleLogin = useSelector(selectIsGoogleLogin);

  const handleSubmit = () => {
    const errors = validateSignupForm({ email: form.email });
    if (errors.length > 0) {
      dispatch(actions.setSignupFormErrors(errors));
      return;
    }
    dispatch(
      actions.signupRequest({
        callback: () => {
          dispatch(actions.clearSignUpForm());
          navigate("/auth/verify-email?email=" + form.email.value);
        },
      })
    );
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(actions.setSignupFormValues({ name, value }));
  };
  const isDisabled = (): boolean => {
    return (
      (isGoogleLogin ||
        form.isLoading ||
        !!form.email.error ||
        !form.email.value) &&
      isEmail
    );
  };
  const handleInputKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
           e.preventDefault();
        handleSubmit();
      } else if (e.key === "Escape") {
        setIsEmail(false);
      }
    },
    [handleSubmit]
  );
  return (
    <form className="flex flex-col gap-[20px] w-full max-w-[444px] min-w-[366px] mb-[56px]">
      <GoogleButton />
      {isEmail && (
        <Input
          id="email"
          type="email"
          placeholder="Enter email address"
          icon={<EmailIcon />}
          error={form.email.error}
          value={form.email.value}
          name="email"
          onChange={handleChange}
          disabled={searchParams ? true : false}
          helperText="Signing up with work email makes it easier for coworkers to join your team"
          onKeyDown={handleInputKeyDown}
        />
      )}
      <Button
        type="button"
        isLoading={form.isLoading}
        loaderClassName="border-secondary"
        disabled={isDisabled()}
        disabledClassName="opacity-50"
        className="w-full h-[56px] !border !border-secondary bg-white text-secondary mt-[10px]"
        onClick={(e) => {
          setIsEmail(true);
          isEmail && handleSubmit();
        }}
      >
        Continue with email
      </Button>
    </form>
  );
}
